import { render, staticRenderFns } from "./password-notification.vue?vue&type=template&id=4c611129&scoped=true"
import script from "./password-notification.ts?vue&type=script&lang=js&external"
export * from "./password-notification.ts?vue&type=script&lang=js&external"
import style0 from "./password-notification.scss?vue&type=style&index=0&id=4c611129&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c611129",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { PageModal as VivaAppPageModal } from '@/components'
installComponents(component, {VivaAppPageModal})
